import { Helmet } from "react-helmet-async";

interface PageSEOProps {
  title: string;
  description: string;
  path?: string;
  noIndex?: boolean;
  ogImage?: string;
}

const BASE_URL = "https://kelasai.app";

export default function PageSEO({
  title,
  description,
  path = "",
  noIndex = false,
  ogImage = "https://storage.googleapis.com/gpt-engineer-file-uploads/lDAUMQeJqrOHg237rV3SaRPXEOt1/social-images/social-1775598736135-KelasAI.webp",
}: PageSEOProps) {
  const canonical = `${BASE_URL}${path}`;
  const fullTitle = title.includes("KelasAI") ? title : `${title} | KelasAI`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
